import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Svelte takes the best of React and the best of Vue to make something awesome",
  "description": "",
  "published": "2019-05-20T00:00:00.000Z",
  "redirect_from": ["/blog/svelte-takes-the-best-of-react-and-the-best-of-vue-to-make-something-awesome/swizec/9089"],
  "categories": "Front End, Technical",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Yesterday I tried `}<a parentName="p" {...{
        "href": "https://svelte.dev/"
      }}>{`Svelte`}</a>{` to see what all the fuss is about. Version 3.0.0 came out recently and it smells like Svelte is ready for the big time.`}</p>
    <p><a parentName="p" {...{
        "href": "https://svelte.dev/"
      }}><img parentName="a" {...{
          "src": "/8de35400c1a46d910d1238af0fab8120/zontalsvgg11a18.svg",
          "alt": null
        }}></img></a></p>
    <p>{`You can watch the livestream here 👇`}</p>
    <lite-youtube {...{
      "videoid": "Wf6JeMPvM9Y",
      "videostartat": "0"
    }}></lite-youtube>
    <p>{`Created by @rich_harris, Svelte's unique idea is that there's no runtime. The framework compiles itself away to become vanilla JavaScript and create the smallest bundles you ever did see.`}</p>
    <p>{`Plus a few features to make development absolutely painless:`}</p>
    <ul>
      <li parentName="ul">{`plain JavaScript in every file`}</li>
      <li parentName="ul">{`plain CSS automatically scoped to components`}</li>
      <li parentName="ul">{`plain HTML ... with some additions`}</li>
      <li parentName="ul">{`no state management`}</li>
    </ul>
    <p>{`You `}<em parentName="p">{`can`}</em>{` use plain HTML. You need the extensions to interact with Svelte and your code. Such is life.`}</p>
    <p>{`Building with Svelte feels like magic. Lemme show you 👇`}</p>
    <h2 {...{
      "id": "building-a-marvel-movie-timeline-with-svelte"
    }}>{`Building a Marvel movie timeline with Svelte`}</h2>
    <p>{`We built a Marvel Movie timeline; 22 movies sorted by their timeline inside the Marvel Cinematic Universe. The `}<a parentName="p" {...{
        "href": "https://www.amctheatres.com/amc-scene/the-best-way-to-rewatch-the-mcu"
      }}>{`AMC website`}</a>{` helped out with a list coz I had no idea there were so many Marvel movies 😅`}</p>
    <p><a parentName="p" {...{
        "href": "https://svelte-app-wswwlsldbg.now.sh/"
      }}><img parentName="a" {...{
          "src": "/ba06ed3570ec6f6639c3486f13b9ba35/aedDYza.gif",
          "alt": null
        }}></img></a></p>
    <p>{`Click 👆 to try it in action. Total JavaScript size just 17.2KB, or 7.2KB when compressed for transfer.`}</p>
    <p>{`That still sounds like a lot for this app, but it's less than React where you some 40KB goes just to React itself. The CSS compiled into a 1KB file with random classes for scoping. There's nothing else.`}</p>
    <p>{`App loads fast and works fast 👌`}</p>
    <p>{`You can `}<a parentName="p" {...{
        "href": "https://github.com/Swizec/svelte-marvel-movie-timeline"
      }}>{`see the full code on GitHub`}</a>{`. Importing the repo into CodeSandbox didn't quite work and I'm not sure why.`}</p>
    <p>{`Best way to start a new Svelte project is with the CLI`}</p>
    <pre><code parentName="pre" {...{}}>{`$ npx degit sveltejs/template my-svelte-project
$ cd my-svelte-project
$ yarn install
$ yarn dev
`}</code></pre>
    <p>{`That creates a new `}<inlineCode parentName="p">{`Hello World`}</inlineCode>{` project in `}<inlineCode parentName="p">{`my-svelte-project`}</inlineCode>{` and runs the dev server. Go to `}<inlineCode parentName="p">{`localhost:5000`}</inlineCode>{` and start hacking. Every change triggers a page reload so you can see what you're doing.`}</p>
    <p>{`I didn't have to install anything new to make the above commands work 🤷‍♂️`}</p>
    <h3 {...{
      "id": "a-svelte-component"
    }}>{`A Svelte component`}</h3>
    <p>{`Svelte components live in `}<inlineCode parentName="p">{`.svelte`}</inlineCode>{` files, split into 3 sections:`}</p>
    <ol>
      <li parentName="ol">{`JavaScript inside `}<inlineCode parentName="li">{`<script>`}</inlineCode>{` tags`}</li>
      <li parentName="ol">{`CSS inside `}<inlineCode parentName="li">{`<style>`}</inlineCode>{` tags`}</li>
      <li parentName="ol">{`HTML at the bottom`}</li>
    </ol>
    <p>{`Our `}<inlineCode parentName="p">{`App.svelte`}</inlineCode>{` component looks like this.`}</p>
    <pre><code parentName="pre" {...{}}>{`<code class="javascript">// src/App.svelte
<script>
  // import other components
  import MarvelMovies from "./MarvelMovies.js";
  import Movie from "./Movie.svelte";
  import Header from "./Header.svelte";
  import Footer from "./Footer.svelte";

  // this is automatically reactive
  let index = 0;

  // assigning new values in functions triggers re-renders
  function nextMovie() {
    index = (index + 1) % MarvelMovies.length;
  }

  function prevMovie() {
    index = index - 1;
    if (index < 0) {
      index = MarvelMovies.length - 1;
    }
  }
</script>

<style>
  // all of this gets scoped to your component
  .grid-container {
    display: grid;
    grid-template-columns: 0.1fr 2.9fr 0.1fr;
    grid-template-rows: 0.1fr 2.8fr 0.1fr;
    grid-template-areas: "h1 h2 h3" "b1 b2 b3" "f1 f2 f3";
  }

  button {
    cursor: pointer;
  }
</style>

// free floating HTML is kinda neat
<div class="grid-container">
  <Header />

  <button on:click={prevMovie} style="grid-area:b1">👈</button>

  <Movie {...MarvelMovies[index]} />

  <button on:click={nextMovie} style="grid-area:b3">👉</button>

  <Footer />
</div>
`}</code></pre>
    <p>{`You might wanna install the Svelte plugin for VSCode to have proper syntax highlighting, Prettier support, and all the rest. The plugin did cause some weird issues while I was streaming, but who knows what that was.`}</p>
    <p>{`A few interesting things to note about `}<inlineCode parentName="p">{`App.svelte`}</inlineCode>{`:`}</p>
    <ul>
      <li parentName="ul">{`You can import `}<inlineCode parentName="li">{`.svelte`}</inlineCode>{` components just like normal JavaScript`}</li>
      <li parentName="ul">{`Every `}<inlineCode parentName="li">{`let`}</inlineCode>{` variable becomes reactive by default`}</li>
      <li parentName="ul">{`Assigning new values in functions triggers re-renders. No need to think about any of that`}</li>
      <li parentName="ul">{`Your CSS is scoped to your component so there's no bleed-over`}</li>
      <li parentName="ul">{`Your HTML free-floats at the bottom`}</li>
      <li parentName="ul">{`Just like in JSX, Svelte components become HTML-like elements`}</li>
      <li parentName="ul">{`Dynamic values go in curly braces, `}<inlineCode parentName="li">{`{}`}</inlineCode>{`, same as JSX`}</li>
    </ul>
    <p>{`My favorite way to use custom components and add dynamic values to HTML. Vue's approach never quite made sense to me 😇`}</p>
    <h3 {...{
      "id": "a-svelte-component-with-props"
    }}>{`A Svelte component with props`}</h3>
    <p>{`Where I think Svelte really shines is building components for re-use. Like the `}<inlineCode parentName="p">{`<Movie />`}</inlineCode>{` component we used above to render the Movie view.`}</p>
    <pre><code parentName="pre" {...{}}>{`<code class="javascript">// src/Movie.svelte

<script>
  export let title;
  export let description;
  export let image;
  export let yearOut;
</script>

<style>
  .main {
    grid-area: b2;

    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 0.1fr 400px 1.1fr;
    grid-template-areas: "title" "thumbnail" "description";
  }

  h2 {
    text-align: center;
    grid-area: title;
  }

  img {
    max-height: 100%;
    max-width: 640px;
    display: block;
  }

  .thumbnail {
    grid-area: thumbnail;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  p {
    grid-area: description;
    padding: 0 1em;
  }
</style>

<div class="main">
  <h2>{title}</h2>

  <div class="thumbnail">
    <img src={image} alt={\`\${title} movie thumbnail\`} />
  </div>

  <p>{description}</p>

</div>
`}</code></pre>
    <p>{`Yep it's mostly CSS.`}</p>
    <p>{`You declare props by exporting `}<inlineCode parentName="p">{`let`}</inlineCode>{` variables. Use them just like you would props in React 👉 `}<inlineCode parentName="p">{`<Movie title="Iron Man" description="..." />`}</inlineCode>{`.`}</p>
    <p>{`Because our Movie props come from a variable, we used a spread and that worked too. `}<inlineCode parentName="p">{`<Movie {...MarvelMovies[index]} />`}</inlineCode>{`.`}</p>
    <p>{`Notice that my CSS is very sloppy.`}</p>
    <p>{`I'm redefining `}<inlineCode parentName="p">{`h2`}</inlineCode>{`, `}<inlineCode parentName="p">{`img`}</inlineCode>{`, and `}<inlineCode parentName="p">{`p`}</inlineCode>{` tags and yet it's totally fine. Svelte scopes it all to the `}<inlineCode parentName="p">{`<Movie>`}</inlineCode>{` component.`}</p>
    <p>{`Whatever CSS you write here affects this file/component only and that's neat.`}</p>
    <p>{`Plus there was no boilerplate at all to get props working, reactive, and passed into the template. To be fair, the same React component looks like this:`}</p>
    <pre><code parentName="pre" {...{}}>{`<code class="javascript">// <Movie> as React
const Style = styled.div\`
  grid-area: b2;

  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 0.1fr 400px 1.1fr;
  grid-template-areas: "title" "thumbnail" "description";

  h2 {
    text-align: center;
    grid-area: title;
  }

  img {
    max-height: 100%;
    max-width: 640px;
    display: block;
  }

  .thumbnail {
    grid-area: thumbnail;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  p {
    grid-area: description;
    padding: 0 1em;
  }
\`

const Movie = ({ title, description, image, yearOut }) => (
    <Style>
      <h2>{title}</h2>

      <div class="thumbnail">
        <img src={image} alt={\`\${title} movie thumbnail\`} />
      </div>

      <p>{description}</p>

    </Style>
)
`}</code></pre>
    <p>{`Which isn't so bad either 🤔`}</p>
    <h2 {...{
      "id": "sveltes-reactivity"
    }}>{`Svelte's reactivity`}</h2>
    <p>{`Where Svelte shines is its reactivity. Look at all the state management for our app`}</p>
    <pre><code parentName="pre" {...{}}>{`<code class="javascript">  // this is automatically reactive
  let index = 0;

  // assigning new values in functions triggers re-renders
  function nextMovie() {
    index = (index + 1) % MarvelMovies.length;
  }

  function prevMovie() {
    index = index - 1;
    if (index < 0) {
      index = MarvelMovies.length - 1;
    }
  }
`}</code></pre>
    <p>{`Define a variable, `}<inlineCode parentName="p">{`index`}</inlineCode>{`, change it inside methods. When its value changes, the component re-renders.`}</p>
    <p>{`😍`}</p>
    <p>{`As far as I understand, Svelte is smart enough to re-render only the HTML nodes that rely on the `}<inlineCode parentName="p">{`index`}</inlineCode>{` variable. Sort of like what you can achieve with MobX and React if you're super careful.`}</p>
    <p>{`This does seem easier than React's `}<inlineCode parentName="p">{`setState`}</inlineCode>{`. Less to think about.`}</p>
    <p>{`However, reactivity can come to bite you in the butt with more complex apps. Sometimes it leads to an effect like screen tearing where parts of the UI update before everything is ready.`}</p>
    <p>{`Imagine if instead of changing `}<inlineCode parentName="p">{`index`}</inlineCode>{`, each button click changed `}<inlineCode parentName="p">{`title`}</inlineCode>{`, `}<inlineCode parentName="p">{`image`}</inlineCode>{`, and `}<inlineCode parentName="p">{`description`}</inlineCode>{` separately. You might get each part of the UI updating on its own without waiting for all 3 to finish changing.`}</p>
    <p>{`For that, Svelte comes with a built-in `}<a parentName="p" {...{
        "href": "https://svelte.dev/docs#createEventDispatcher"
      }}>{`dispatcher`}</a>{`. I haven't used it, but looks like it gives you functionality similar to Redux.`}</p>
    <h2 {...{
      "id": "sveltes-event-handling"
    }}>{`Svelte's event handling`}</h2>
    <p>{`Another neat Svelte feature is the event handling.`}</p>
    <p>{`Svelte uses what I believe are called directives. `}<inlineCode parentName="p">{`thing:something`}</inlineCode>{` syntax added to the HTML. Remember when I said there's no such thing as plain HTML in modern JS? 😛`}</p>
    <p>{`We used the `}<inlineCode parentName="p">{`on:`}</inlineCode>{` directive to make buttons work`}</p>
    <pre><code parentName="pre" {...{}}>{`<code class="html"><button on:click={prevMovie} style="grid-area:b1">👈</button>
`}</code></pre>
    <p>{`Call the `}<inlineCode parentName="p">{`prevMovie`}</inlineCode>{` function when the button is clicked.`}</p>
    <p>{`That's it. No binding. No passing params. No nothing. Svelte figures it all out on its own.`}</p>
    <h2 {...{
      "id": "sveltes-template-logic"
    }}>{`Svelte's template logic`}</h2>
    <p>{`This is where I think Svelte fumbles. `}<a parentName="p" {...{
        "href": "https://svelte.dev/examples#else-blocks"
      }}>{`Svelte's template logic`}</a>{` is easy to use, but reminiscent of old Mustache or Handlebars syntax.`}</p>
    <pre><code parentName="pre" {...{}}>{`<code class="javascript">{#if user.loggedIn}
    <button on:click={toggle}>
        Log out
    </button>
{:else}
    <button on:click={toggle}>
        Log in
    </button>
{/if}
`}</code></pre>
    <p>{`Not sure how I feel about that 🤔`}</p>
    <p>{`Easy to read, yes, easier to write than React's nested ternary expressions, definitely, but means you have to learn another syntax beyond JavaScript, CSS, and HTML. Which can be good or bad.`}</p>
    <p>{`Depends what you're doing I guess. For simple stuff this is great.`}</p>
    <h2 {...{
      "id": "the-verdict"
    }}>{`The verdict?`}</h2>
    <p>{`Svelte is great. Quick to get started, easy to use, good ergonomics, not too complex. Like other frameworks, I'd have to build some bigger projects to see how it feels in the real world.`}</p>
    <p>{`That's where I've found in the past that React shines. With bigger more complex projects. Whereas Vue, in my experience, is quick to get started but breaks down with complexity.`}</p>
    <p>{`Svelte? I don't know yet.`}</p>
    <p>{`But it feels like Svelte takes the best of React and the best of Vue to make something awesome.`}</p>
    <p>{`I recommend you `}<a parentName="p" {...{
        "href": "https://svelte.dev/examples"
      }}>{`dig through the examples`}</a>{`. They're great and show off Svelte's best features.`}</p>
    <p>{`Like the built-in transition support. Love it 👌`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      